<template>
    <div>
        <MulReportHeader :dataFrom="table.params" @search="searchData" :toPdf="eleToPdf"></MulReportHeader>
        <Table border :columns="table.columns" :data="table.data" style="margin-top: 12px" ref="tableRef"></Table>
    </div>
</template>

<script>
import MulReportHeader from './components/mul_report_header.vue'
import { TransTopReq } from '@/api/admin/risk'
export default {
    name: 'HandicapReplenData',
    components: { MulReportHeader },
    data() {
        return {
            loading: false,
            TransTopReqTimer: null,
            timestamp: 0,
            tableTotal: this.getTableTotal(),
            table: {
                params: {
                    platids: [],
                    app_ids: [],
                    dataTime: this.getCurrentZeroDay()
                },
                data: [],
                columns: [
                    {
                        key: 'app_name',
                        width: 110,
                        align: 'center',
                        renderHeader: (h) => this.renderHeader(h, '盘口', '显示对应的盘口名称')
                    },
                    {
                        key: 'new_user_num',
                        minWidth: 80,
                        align: 'center',
                        renderHeader: (h) => this.renderHeader(h, '新增人数', '筛选时间内,盘口新增人数')
                    },
                    {
                        key: 'new_user_pay_num',
                        minWidth: 80,
                        align: 'center',
                        renderHeader: (h) => this.renderHeader(h, '新增转入人数', '筛选时间内,盘口新增且转入人数')
                    },
                    {
                        key: 'new_user_pay_total_sum',
                        minWidth: 80,
                        align: 'center',
                        renderHeader: (h) => this.renderHeader(h, '新增转入总金额', '筛选时间内,盘口新增转入人数转入总额'),
                        render: (h, params) => h('span', this.getCustomFixed(params.row.new_user_pay_total_sum / 10000))
                    },
                    {
                        key: 'zhuan_rate',
                        minWidth: 80,
                        align: 'center',
                        renderHeader: (h) => this.renderHeader(h, '新增转化率', '筛选时间内,盘口新增转入人数 / 新增人数'),
                        render: (h, params) => h('span', (params.row.zhuan_rate * 100 || 0).toFixed(2) + '%')
                    },
                    {
                        key: 'first_pay_num',
                        minWidth: 80,
                        align: 'center',
                        renderHeader: (h) => this.renderHeader(h, '首充人数', '筛选时间内,盘口首充人数')
                    },
                    {
                        key: 'pay_ave',
                        minWidth: 80,
                        align: 'center',
                        renderHeader: (h) => this.renderHeader(h, 'ARPPU', '统计盘口筛选时间内的【转入金额】/【转入人数】'),
                        render: (h, params) => h('span', this.getCustomFixed(params.row.pay_ave / 10000))
                    },
                    {
                        key: 'pay_sum',
                        minWidth: 80,
                        align: 'center',
                        renderHeader: (h) => this.renderHeader(h, '转入金额', '统计盘口筛选时间内的转入金额'),
                        render: (h, params) => h('span', this.getCustomFixed(params.row.pay_sum / 10000))
                    },
                    {
                        key: 'ci_ri_pay_rate',
                        minWidth: 80,
                        align: 'center',
                        renderHeader: (h) => this.renderHeader(h, '次日复充率', '统计盘口筛选时间内的转入用户次日复充率'),
                        render: (h, params) => h('span', (params.row.ci_ri_pay_rate * 100 || 0).toFixed(2) + '%')
                    },
                    {
                        key: 'pay_put_sum',
                        minWidth: 80,
                        align: 'center',
                        renderHeader: (h) => this.renderHeader(h, '充提差', '统计盘口筛选时间内的转入金额 - 提款金额'),
                        render: (h, params) => h('span', this.getCustomFixed(params.row.pay_put_sum / 10000))
                    }
                ]
            }
        }
    },
    methods: {
        //查询数据
        searchData(emitProps) {
            let allList = this.getAllHttpAppid(this.table.params)
            let httpList = []
            let loadingArr = [...allList]
            let stime = this.getSecond(this.table.params.dataTime)
            let etime = this.getSecond(this.table.params.dataTime, false)
            this.timestamp = new Date().getTime() //设置请求时间
            this.table.data = []
            for (let i = 0, len = allList.length; i < len; i++) {
                let app_id = allList[i]
                let app_name = ''
                let platid = 0
                let item = emitProps.app_list.find((el) => el.appid == app_id)
                if (item) {
                    app_name = item.appName
                    platid = item.platform
                }
                let el = { platid, app_id, app_name }
                let param = this.getTransTopParams('GetNewPlatfromData', { platid, app_id, app_name, stime, etime, general: -1, pack_no: -1, page: 1, limit: 10000, sort: 0, timestamp: this.timestamp })
                httpList.push(param)
            }
            this.tableTotal = this.getTableTotal()
            let max = Math.min(5, httpList.length)
            for (let i = 0; i < max; i++) {
                this.toHttp(httpList, loadingArr)
            }
        },
        async toHttp(httpList, loadingArr) {
            if (httpList.length > 0) {
                let param = httpList.shift()
                if (this.isCurrentHttp(param.timestamp)) {
                    this.openTimer()
                    let canNext = true
                    //请求平台数据
                    let res = await TransTopReq(param)
                    canNext = this.isCurrentHttp(param.timestamp) && !!res._param
                    if (canNext) {
                        let data = res._param.data[0]
                        let param2 = this.copyData(param)
                        param2.param._func = 'GetNewPlatformRepeatPayInfo'
                        let res2 = await TransTopReq(param2)
                        canNext = this.isCurrentHttp(param.timestamp) && res2._param
                        if (canNext) {
                            let data2 = res2._param.data[0]
                            data.ci_ri_pay_rate = data2.ci_ri_pay_rate || 0
                            data.ci_ri_pay_num = data2.ci_ri_pay_num || 0

                            this.tableTotal.first_pay_num += data.first_pay_num || 0 //首充人数
                            this.tableTotal.new_user_num += data.new_user_num || 0 //新增人数
                            this.tableTotal.new_user_pay_num += data.new_user_pay_num || 0 //新增转入人数
                            this.tableTotal.new_user_pay_total_sum += data.new_user_pay_total_sum || 0 //新增转入金额
                            this.tableTotal.pay_put_sum += data.pay_put_sum || 0 //充提差
                            this.tableTotal.pay_sum += data.pay_sum || 0 //转入金额
                            this.tableTotal.pay_user_num += data.pay_user_num //转入人数
                            this.tableTotal.ci_ri_pay_num += data.ci_ri_pay_sum //次日转入人数
                            this.tableTotal.ci_ri_pay_rate = this.calcRate(this.tableTotal.ci_ri_pay_num, this.tableTotal.pay_user_num) //次日复充率
                            this.tableTotal.pay_ave = this.calcRate(this.tableTotal.pay_sum, this.tableTotal.pay_user_num) //ARPPU
                            this.tableTotal.zhuan_rate = this.calcRate(this.tableTotal.new_user_pay_num, this.tableTotal.new_user_num) //新增转化率
                            loadingArr.shift()
                            data.app_name = param.app_name
                            this.table.data.pop()
                            let result = [...this.table.data, data, this.tableTotal]
                            this.table.data = result
                            if (httpList.length > 0) {
                                this.toHttp(httpList, loadingArr)
                            }
                            if (loadingArr.length == 0) {
                                this.closeTimer()
                            }
                        }
                    }
                }
            }
        },
        getTableTotal() {
            return {
                app_name: '合计',
                new_user_num: 0,
                new_user_pay_num: 0,
                new_user_pay_total_sum: 0,
                first_pay_num: 0,
                zhuan_rate: 0,
                pay_ave: 0,
                user_pay_num: 0,
                pay_put_sum: 0,
                ci_ri_pay_rate: 0,
                pay_sum: 0,
                pay_user_num: 0
            }
        },
        //关闭定时器
        closeTimer() {
            this.loading = false
            clearTimeout(this.TransTopReqTimer)
            this.TransTopReqTimer = null
        },
        //批量请求开启定时器8秒超时
        openTimer() {
            this.closeTimer()
            this.loading = true
            this.TransTopReqTimer = setTimeout(() => {
                this.loading = false
            }, 6000)
        },
        //透传接口请求参数 请求方法 请求参数
        getTransTopParams(func, param) {
            return {
                mod: 'root',
                platid: param.platid,
                app_id: param.app_id,
                app_name: param.app_name,
                timestamp: param.timestamp,
                param: {
                    _mod: 'manager',
                    _func: func,
                    _param: {
                        ...param
                    }
                }
            }
        },

        isCurrentHttp(timestamp) {
            return timestamp == this.timestamp
        }
    }
}
</script>

<style scoped lang="less"></style>
